import { Separator } from "@radix-ui/react-separator"
import { SidebarTrigger } from "./ui/sidebar"
import { type BreadcrumbOptions, Breadcrumbs } from "./breadcrumbs"
import { HomeIcon as House } from "lucide-react"
import { T } from "@/i18n"

export function PageHeader({
  breadcrumbs,
}: {
  breadcrumbs: BreadcrumbOptions[]
}) {
  return (
    <header className="flex h-16 shrink-0 items-center gap-2 border-b px-4">
      <SidebarTrigger className="-ml-1" />
      <Separator orientation="vertical" className="mr-2 h-4" />
      <Breadcrumbs
        crumbs={[
          {
            content: (
              <>
                <T tKey="home.title" /> <House width={16} height={16} />
              </>
            ),
            href: "/",
          },
          ...breadcrumbs,
        ]}
      />
    </header>
  )
}
